
import { Options, Prop, Vue } from 'vue-property-decorator';
import NavigationFooter from '@/components/NavigationFooter.vue';
import TestReview from './TestReview.vue';
import TestController from '@/controllers/TestController';
import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import DisplayItem from '@/models/DisplayItem';

@Options({
  components: { TestReview, NavigationFooter },
})
export default class ReviewScreen extends Vue {
  @Prop() readonly testController: TestController | undefined;

  getPreviousButtonText(): string {
    return this.$t('btn.back');
  }

  getTitle(): string {
    const endOfTest: boolean | undefined = this.testController?.navigationController?.endOfTest();
    if (endOfTest && !this.sectionLockEnabled()) {
      return this.$t('review.assessment');
    } else {
      return this.$t('review.section');
    }
  }

  getNextButtonText(): string {
    const endOfTest: boolean | undefined = this.testController?.navigationController?.endOfTest();

    if (endOfTest !== undefined && endOfTest) {
      return this.$t('modal.submit_header');
    } else {
      const nextItem: DisplayItem | null | undefined = this.testController?.navigationController?.peekNextItem();
      let value = this.$t('btn.continue');
      if (nextItem) {
        value = this.$t('btn.continue_to') + ' ' + nextItem.section.title;
      }
      return value;
    }
  }

  useSubmitIconWithNextButton(): boolean {
    const endOfTest: boolean | undefined = this.testController?.navigationController?.endOfTest();

    return endOfTest !== undefined && endOfTest;
  }

  isTestEndReview(): boolean {
    return this.testController && this.testController.navigationController
      ? this.testController.navigationController.lastSectionInTest()
      : false;
  }

  flagItemEnabled(): boolean {
    return this.testController
      ? this.testController.deliveryOptionEnabledForTest(DeliveryOptionConstants.FLAG_ITEM)
      : false;
  }

  sectionLockEnabled(): boolean {
    return this.testController
      ? this.testController.deliveryOptionEnabledForTest(DeliveryOptionConstants.BLOCK_RETURN_TO_SECTION)
      : false;
  }
}
